<template>
  <div>
    <v-card flat v-if="screener.id">
      <v-card-text v-if="magicLink" class="pa-0">
        <v-card-text class="text-xs-center pa-0">
          <v-layout row wrap class="lighten-4 pa-4">
            <v-flex xs6>
              <div>
                <div class="headline font-weight-light">
                  {{ DEFINES.ACCESS_LINK_STATUS_STR[magicLink.status] }}
                </div>
                <div class="subheading saSecondary--text">
                  {{ $t("Screener.save.magic.link.status.title") }}
                </div>
              </div>
            </v-flex>

            <v-flex xs6>
              <div>
                <div class="headline font-weight-light">
                  {{ magicLink.no_of_used }}
                </div>
                <div class="subheading saSecondary--text">
                  {{ $t("Screener.save.magic.link.redeemed.title") }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-dialog
          v-model="editorDialog"
          scrollable
          persistent
          :overlay="false"
          width="70%"
          transition="dialog-transition"
        >
          <v-card>
            <v-card-title class="pa-2 primary" primary-title>
              <span class="white--text subheading">Manage Magic link</span>
              <v-spacer></v-spacer>
              <v-btn
                @click="$emit('update:editorDialog', false)"
                icon
                color="white--text"
              >
                <v-icon>$vuetify.icons.rms_close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pa-4">
              <v-card-actions class="mb-4">
                <div class="grey--text subheading font-weight-medium">
                  <span>{{ $t("Screener.save.magic.link.status.title") }}</span
                  >:
                  <span>{{
                    DEFINES.ACCESS_LINK_STATUS_STR[magicLink.status]
                  }}</span>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="magicLink.status == DEFINES.ACCESS_LINK.STATUS.PAUSED"
                  outline
                  color="primary"
                  @click="activateMagicLink()"
                  >{{
                    $t("screener.save.magic.link.button.mark.active")
                  }}</v-btn
                >
                <v-btn
                  v-if="magicLink.status == DEFINES.ACCESS_LINK.STATUS.ACTIVE"
                  outline
                  color="primary"
                  :disabled="
                    magicLink.status == DEFINES.ACCESS_LINK.STATUS.PAUSED ||
                    magicLink.status == DEFINES.ACCESS_LINK.STATUS.EXPIRED
                  "
                  @click="
                    openAccessLinkDialogWith(
                      $t('screener.save.magic.link.title.mark.paused'),
                      $t('rms.button.continue'),
                      $t('rms.button.cancel'),
                      DEFINES.MAGIC_LINK_WARNINGS.PAUSE,
                      'markMagicLinkPause'
                    )
                  "
                  >{{
                    $t("screener.save.magic.link.button.mark.paused")
                  }}</v-btn
                >
                <v-btn
                  outline
                  color="primary"
                  :disabled="
                    magicLink.status == DEFINES.ACCESS_LINK.STATUS.EXPIRED
                  "
                  @click="
                    openAccessLinkDialogWith(
                      $t('screener.save.magic.link.title.mark.expire'),
                      $t('rms.button.continue'),
                      $t('rms.button.cancel'),
                      DEFINES.MAGIC_LINK_WARNINGS.EXPIRE,
                      'markMagicLinkExpired'
                    )
                  "
                  >{{
                    $t("screener.save.magic.link.button.mark.expire")
                  }}</v-btn
                >
                <v-btn
                  outline
                  color="error"
                  @click="
                    openAccessLinkDialogWith(
                      $t('screener.save.magic.link.title.mark.delete'),
                      $t('rms.button.continue'),
                      $t('rms.button.cancel'),
                      DEFINES.MAGIC_LINK_WARNINGS.DELETE,
                      'deleteMagicLink'
                    )
                  "
                  >{{ $t("screener.save.magic.link.button.delete") }}</v-btn
                >
                <v-btn
                  outline
                  color="primary"
                  @click="
                    openAccessLinkDialogWith(
                      $t('screener.save.magic.link.button.generate_new'),
                      $t('rms.button.continue'),
                      $t('rms.button.cancel'),
                      DEFINES.MAGIC_LINK_WARNINGS.GENERATE_NEW,
                      'generateNewMagicLink'
                    )
                  "
                  >{{
                    $t("screener.save.magic.link.title.mark.generate_new")
                  }}</v-btn
                >
              </v-card-actions>
              <v-layout row wrap v-if="screener.id != undefined">
                <v-flex xs12 md11 lg11>
                  <v-text-field
                    id="registration_link"
                    :label="$t('screener.save.magic.link.title')"
                    name="registration_link"
                    readonly
                    color="primary"
                    prepend-icon="$vuetify.icons.rms_media_link"
                    type="text"
                    :value="magicLink.skip_prompt?`${magic_link_url}?sp=1`:magic_link_url"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md1 lg1 mt-2>
                  <v-btn
                    dark
                    small
                    color="success"
                    @click="$copyText((magicLink.skip_prompt?`${magic_link_url}?sp=1`:magic_link_url))"
                  >
                    <v-icon small class="mr-2">$vuetify.icons.rms_copy</v-icon>
                    {{ $t("screener.btn.copy") }}
                  </v-btn>
                </v-flex>
                <v-flex x12>
                  <v-checkbox @change="updateMagicLink" v-model="magicLink.skip_prompt" color="primary">
                    <template v-slot:label>
                      <div style="display: flex; align-items: center;">
                        {{ $t('screener.magic_link.enable_quick_login') }}
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon class="ml-2" v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <span class="black--text">{{ $t('screener.magic_link.enable_quick_login.tooltip') }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
              <div>
                <div class="subheading grey--text mb-2">Remember</div>
                <ul
                  v-for="item in DEFINES.MAGIC_LINK_WARNINGS.GENERATE"
                  :key="item"
                >
                  <li>{{ item }}</li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-card-text v-else class="text-xs-center text-md-center">
        <div class="pa-2">
          <v-btn
            color="primary"
            dark
            @click="
              openAccessLinkDialogWith(
                $t('screener.save.magic.link.title'),
                $t('screener.save.magic.link.generate.dialog.confirm.button'),
                $t('screener.save.magic.link.generate.dialog.cancel.button'),
                DEFINES.MAGIC_LINK_WARNINGS.GENERATE,
                'generateMagicLink'
              )
            "
            >{{ $t("screener.save.magic.link.generate") }}</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
    <ConfirmationDialogBox
      :title="accessLinkDialog.title"
      :dialog="accessLinkDialog.visible"
      :yesBtnText="accessLinkDialog.yesBtnText"
      :noBtnText="accessLinkDialog.noBtnText"
      @confirm="handleConfirmation(accessLinkDialog.action)"
      @cancel="resetAccessLinkDialog"
    >
      <div v-if="accessLinkDialog.content && accessLinkDialog.content.length">
        <div class="subheading grey--text mb-2">Remember</div>
        <ul v-for="item in accessLinkDialog.content" :key="item">
          <li>{{ item }}</li>
        </ul>
      </div>
    </ConfirmationDialogBox>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import DEFINES from "@/defines";
import ConfirmationDialogBox from "@/components/dialogBox/DynamicConfirmationBox";
import i18n from "@/i18n";
export default {
  name: "AccessLink",
  props: {
    screener: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
    },
    editorDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      accessLinkDialog: {
        visible: false,
        title: null,
        yesBtnText: null,
        noBtnText: null,
        content: null,
        action: null,
      },
      manageDialog: false,
      magic_link_url: null,
    };
  },
  components: {
    ConfirmationDialogBox,
  },
  mounted() {
    this.getMagicLink();
  },
  computed: {
    ...mapFields("screenerAccessLink", {
      magicLink: "magic_link",
    }),
  },
  methods: {
    async generateMagicLink() {
      await this.$store
        .dispatch("screenerAccessLink/generateMagicLink", {
          screener_id: this.screener.id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.save.magic.link.generated.successfully"),
            color: "success",
          });
          if (response.magic_link) {
            var uuid = response.magic_link.id;
            this.magic_link_url = `${this.company.domain}/screeners/${this.$route.params.screener_id}/link/${uuid}`;
          }
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async getPreviewLink() {
      await this.$store
        .dispatch("screenerAccessLink/getPreviewLink", {
          screener_id: this.screener.id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.save.magic.link.generated.successfully"),
            color: "success",
          });
          if (response.preview_link) {
            var uuid = response.preview_link.id;
            var preview_link = `${this.company.domain}/screeners/${this.$route.params.screener_id}/link/${uuid}`;
            window.open(preview_link, "_blank");
          }
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async markMagicLinkPause() {
      await this.$store
        .dispatch("screenerAccessLink/markMagicLinkPaused", {
          screener_id: this.screener.id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t(
              "screener.save.magic.link.marked.paused.success.message"
            ),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async activateMagicLink() {
      await this.$store
        .dispatch("screenerAccessLink/activateMagicLink", {
          screener_id: this.screener.id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t(
              "screener.save.magic.link.activated.success.message"
            ),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async markMagicLinkExpired() {
      await this.$store
        .dispatch("screenerAccessLink/markMagicLinkExpired", {
          screener_id: this.screener.id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t(
              "screener.save.magic.link.marked.expire.success.message"
            ),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async deleteMagicLink() {
      await this.$store
        .dispatch("screenerAccessLink/deleteMagicLink", {
          screener_id: this.screener.id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t(
              "screener.save.magic.link.marked.delete.success.message"
            ),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async generateNewMagicLink() {
      await this.$store
        .dispatch("screenerAccessLink/generateNewMagicLink", {
          screener_id: this.screener.id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.save.magic.link.generated.successfully"),
            color: "success",
          });
          if (response.magic_link) {
            var uuid = response.magic_link.id;
            this.magic_link_url = `${this.company.domain}/screeners/${this.$route.params.screener_id}/link/${uuid}`;
          }
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async getMagicLink() {
      ///Fixme: Do not fetch magic like while creating (Handle it properly)
      if (!(this.$route.name == "screener.save")) {
        return;
      }
      await this.$store
        .dispatch("screenerAccessLink/getMagicLink", {
          screener_id: this.$route.params.screener_id,
        })
        .then((response) => {
          if (response.magic_link) {
            var uuid = response.magic_link.id;
            this.magic_link_url = `${this.company.domain}/screeners/${this.$route.params.screener_id}/link/${uuid}`;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },

    async updateMagicLink() {
      await this.$store
        .dispatch("screenerAccessLink/updateMagicLink", this.magicLink)
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t(
              "screener.save.magic.link.updated.successfully"
            ),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    openAccessLinkDialogWith(title, yesBtnText, noBtnText, content, action) {
      this.accessLinkDialog.visible = true;
      this.accessLinkDialog.title = title;
      this.accessLinkDialog.yesBtnText = yesBtnText;
      this.accessLinkDialog.noBtnText = noBtnText;
      this.accessLinkDialog.content = content;
      this.accessLinkDialog.action = action;
    },

    resetAccessLinkDialog() {
      this.accessLinkDialog.visible = false;
      this.accessLinkDialog.title = null;
      this.accessLinkDialog.yesBtnText = null;
      this.accessLinkDialog.noBtnText = null;
      this.accessLinkDialog.content = null;
      this.accessLinkDialog.action = null;
    },

    handleConfirmation(handlerName) {
      this[handlerName]();
    },
  },
};
</script>
